import React from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import { List, ListItemButton, ListItemIcon, ListItemText, Stack, SvgIconProps } from "@mui/material";
import { FileRepoStatus } from "store/types";

interface StatusOption {
  value: FileRepoStatus;
  label: string;
  bgcolor: string;
  iconColor: string;
  Icon: React.ComponentType<SvgIconProps>;
}

const STATUS_OPTIONS: StatusOption[] = [
  { value: "new", label: "New", bgcolor: "#f6f8fc", iconColor: "#496682", Icon: ErrorOutlineIcon },
  { value: "in_process", label: "In Process", bgcolor: "#e2e8fa", iconColor: "#3b5998", Icon: SyncOutlinedIcon },
  {
    value: "waiting_for_information",
    label: "Waiting for Information",
    bgcolor: "#fde4bd",
    iconColor: "#c77700",
    Icon: ScheduleOutlinedIcon
  },
  { value: "done", label: "Done", bgcolor: "#98fcd9", iconColor: "#1b7a4a", Icon: CheckCircleOutlineIcon },
  {
    value: "not_relevant",
    label: "Not Relevant",
    bgcolor: "#dbe8f5",
    iconColor: "#496682",
    Icon: DoNotDisturbOnOutlinedIcon
  }
];

interface Props {
  currentStatus: string | null;
  onSubmit: (result: { status: FileRepoStatus }) => void;
  onCancel: () => void;
}

export const OperationsStatusPrompt: React.FC<Props> = ({ currentStatus, onSubmit }) => (
  <Stack sx={{ minWidth: 240, py: "8px" }}>
    <List disablePadding>
      {STATUS_OPTIONS.map(({ value, label, iconColor, Icon }) => (
        <ListItemButton
          key={value}
          selected={currentStatus === value}
          onClick={() => onSubmit({ status: value })}
          sx={{
            py: "6px",
            px: "16px",
            "&.Mui-selected": { bgcolor: "#edf1f9" },
            "&:hover": { bgcolor: "#f6f8fc" }
          }}
        >
          <ListItemIcon sx={{ minWidth: 28 }}>
            <Icon sx={{ fontSize: 16, color: iconColor }} />
          </ListItemIcon>
          <ListItemText primary={label} sx={{ "& .MuiTypography-root": { fontSize: "14px", color: "#071f35" } }} />
        </ListItemButton>
      ))}
    </List>
  </Stack>
);

export const getStatusConfig = (
  status: string | null
): { label: string; bgcolor: string; iconColor: string; Icon: React.ComponentType<SvgIconProps> } =>
  STATUS_OPTIONS.find((opt) => opt.value === (status as FileRepoStatus)) ?? STATUS_OPTIONS[0];
